var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7422 3.31913C20.0139 -1.08875 11.9859 -1.08875 6.25769 3.31907L15.9999 13.0613L25.7422 3.31913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 18.9642L6.25769 28.7064C11.9859 33.1142 20.0139 33.1142 25.7422 28.7064L15.9999 18.9641L15.9998 18.9642Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0486 16.0127L3.30639 6.27042C-1.10148 11.9987 -1.10148 20.0267 3.30639 25.7549L13.0486 16.0127Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9515 16.0127L28.6937 25.7549C33.1015 20.0267 33.1015 11.9987 28.6937 6.27042L18.9515 16.0127Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.9692C19.8419 22.9692 22.9565 19.8546 22.9565 16.0127C22.9565 12.1707 19.8419 9.05615 16 9.05615C12.158 9.05615 9.04346 12.1707 9.04346 16.0127C9.04346 19.8546 12.158 22.9692 16 22.9692Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 11.1432L16.6024 12.1867H17.8073L17.2048 13.2302L17.8073 14.2737H16.6024L15.9999 15.3172L15.3975 14.2737H14.1926L14.7951 13.2302L14.1926 12.1867H15.3975L15.9999 11.1432Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9379 16.0127L13.5403 17.0562H14.7452L14.1427 18.0996L14.7452 19.1431H13.5403L12.9379 20.1866L12.3354 19.1431H11.1305L11.7329 18.0996L11.1305 17.0562H12.3354L12.9379 16.0127Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0624 16.0127L19.6648 17.0562H20.8697L20.2673 18.0996L20.8697 19.1431H19.6648L19.0624 20.1866L18.4599 19.1431H17.255L17.8574 18.0996L17.255 17.0562H18.4599L19.0624 16.0127Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.690aec21.svg";
export { ForwardRef as ReactComponent };